const WORDS = [
  "Business", "Investment", "Governance", "Education", "Networking",
  "Wealth", "Leadership", "Collaboration", "Legacy", "Community",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden bg-[#041525] border-y border-[#006FD6]/15 py-6 select-none">
    <div className="mst-marquee-track flex whitespace-nowrap w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {WORDS.map((w) => (
            <span key={`${dup}-${w}`} className="flex items-center">
              <span
                className="text-lg sm:text-xl font-extrabold uppercase tracking-[0.3em] text-white/25 px-8"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                {w}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-[#009BFF]/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
